document.addEventListener('DOMContentLoaded', () => {
  let observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        let img = entry.target;
        if (entry.intersectionRatio > 0.0 && !img.hasAttribute('src')) {
          if (img.classList.contains('lazy-background')) {
            img.style.backgroundImage = `url('${img.dataset.img}')`;
          } else {
            img.setAttribute('src', img.dataset.src);
          }
        }
      });
    },
    { rootMargin: '0px 0px 200px 0px' },
  );
  for (let img of document.getElementsByTagName('img')) {
    observer.observe(img);
  }
  for (let video of document.getElementsByTagName('video')) {
    observer.observe(video);
  }
  for (let background of document.getElementsByClassName('lazy-background')) {
    observer.observe(background);
  }
});
